import "../CSS/tantramassagefrau.css";

import TantramassageNavigation
    from "../components/TantramassageNavigation";


function TantramassageFrauPage() {

    return (
        <>

            <TantramassageNavigation />


            <div className="intro">

                <h1>
                    Tantramassage für Frauen im Sarganserland
                </h1>

            </div>


            <main className="massage-frau-main">

                <section className="massage-frau-einstieg">

                    <figure className="massage-frau-bild">

                        <img
                            src="/Fotos/massage_frau.png"
                            alt="Achtsame Tantramassage für Frauen im Sarganserland"
                        />

                        <figcaption>
                            Achtsamkeit, Berührung und Zeit für Dich
                        </figcaption>

                    </figure>


                    <div className="massage-frau-text">

                        <p>
                            Meine Tantramassage für Frauen im Sarganserland
                            ist eine Einladung, in einem geschützten Raum
                            die Achtsamkeit und Präsenz zu empfangen,
                            die Du als Frau verdienst. Mein Angebot richtet
                            sich auch an Frauen aus Mels, Sargans,
                            Bad Ragaz und der umliegenden Region.
                        </p>


                        <p>
                            Ein Raum, in dem Du Dich selbst spüren und Dir
                            begegnen kannst – ohne Druck und ohne etwas
                            zu müssen.
                        </p>


                        <p>
                            Im Zentrum steht Dein Körper als weiblicher Tempel –
                            schützenswert, geliebt und achtsam berührt.
                        </p>


                        <p>
                            Es ist ein Würdigen der weiblichen Sexualität
                            in all ihren Facetten, als Quelle von Kraft,
                            Heilung, Lust und Lebensfreude.
                        </p>

                    </div>

                </section>


                <section className="massage-frau-details">

                    <h2>
                        Die Yoni-Massage
                    </h2>


                    <p>
                        In die Massage kann der ganze Körper mit einbezogen
                        werden. Wenn Du es ausdrücklich wünschst und wir dies
                        vorher gemeinsam vereinbart haben, kann auch eine
                        Yoni-Massage Teil Deiner Tantramassage sein.
                    </p>


                    <p>
                        Eine Yoni-Massage kann sehr unterschiedlich erlebt
                        werden. Sie kann sinnlich und lustvoll sein, aber
                        ebenso tief entspannend und heilsam wirken.
                        Dabei gibt es kein Ziel, das erreicht werden muss.
                    </p>


                    <p>
                        Du entscheidest jederzeit selbst, welche Berührungen
                        für Dich stimmig sind. Deine Wünsche und persönlichen
                        Grenzen stehen während der gesamten Massage im
                        Vordergrund.
                    </p>

                </section>

            </main>

        </>
    );
}


export default TantramassageFrauPage;